
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalSphere as ObiBuoyConicalSphereElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-sphere.js';
 
 
 

 
 export const ObiBuoyConicalSphere = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-sphere',
   elementClass: ObiBuoyConicalSphereElement,
   events: {
     
   }
  });
 
 